import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ChipTableCell from 'components/molecules/TableCells/ChipTableCell/ChipTableCell';

const StyledTimelineTableCell = styled(ChipTableCell)`
  .Chip-size-large {
    min-width: ${props => props.theme.layout(134)};
    max-width: ${props => props.theme.layout(134)};
  }
  
  .Chip {
    justify-content: space-around;
    
    .MuiChip-label {
      text-overflow: unset;
    }
  }
  
  ${ComponentStyles}
`;

StyledTimelineTableCell.propTypes = {
  theme: PropTypes.object
};

export default StyledTimelineTableCell;
